import React from 'react';

import { QueryClientProvider } from '@tanstack/react-query';
import PropTypes from 'prop-types';
import queryClient from 'react-query-settings/queryClient';

import AppWrapper from 'components/apps/AppWrapper';
import UserForm from 'components/settings/users/userForm/components/UserForm';
import { UserFormContext } from 'components/settings/users/userForm/contexts/UserFormContext';

import { resourceShape } from 'components/helpers/serialisableResources';

export default function EntryPoint({ contextProps, wrappedProps }) {
  return (
    <QueryClientProvider client={queryClient}>
      <AppWrapper {...contextProps}>
        <UserFormContext.Provider value={{ ...wrappedProps }}>
          <UserForm />
        </UserFormContext.Provider>
      </AppWrapper>
    </QueryClientProvider>
  );
}

EntryPoint.propTypes = {
  wrappedProps: PropTypes.shape({
    domainUser: PropTypes.shape({
      data: resourceShape('user').isRequired,
      included: PropTypes.array.isRequired,
    }),
    divisions: PropTypes.arrayOf(resourceShape('company')).isRequired,
    personnelText: PropTypes.string.isRequired,
    samlProviderConfiguration: resourceShape('samlProviderConfiguration'),
    teamPolicy: PropTypes.shape({
      canIndex: PropTypes.bool.isRequired,
    }).isRequired,
  }).isRequired,
};
